module.exports = __webpack_public_path__ + "static/scott-mcdonald-214051c0a9e9e5ced18f4a11cee1a91b.jpeg";